import { render, staticRenderFns } from "./PacienteGaleria.vue?vue&type=template&id=53c3dbf2&scoped=true"
import script from "./PacienteGaleria.vue?vue&type=script&lang=js"
export * from "./PacienteGaleria.vue?vue&type=script&lang=js"
import style0 from "./PacienteGaleria.vue?vue&type=style&index=0&id=53c3dbf2&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c3dbf2",
  null
  
)

export default component.exports